<button (click)="apply()" class="apply-button {{'apply-button--' + color }}" [ngClass]="customClass">
  <ng-container *ngIf="!processing">
    <span class="text">{{ text | translate }}</span>
    <span class="icon-wrapper">
      <img src="../../../../../../../assets/job-board/icons/chevron-right.svg" alt="Icon"/>
    </span>
  </ng-container>
  <span a3l-ui-button-spinner *ngIf="processing"></span>
</button>
